/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import Typography from "@mui/material/Typography";
import {currencyAmountFromCents} from "../../../../utils/money";

const BalanceValue = ({value}) => {
  const isNegative = value < 0;
  const sign = isNegative ? "-" : "";
  const color = isNegative ? "primary.dark" : "text.disabled";
  const balance = `${sign}${currencyAmountFromCents(Math.abs(value))}`;

  return (
    <Typography variant="body1" sx={{ color }}>
      {balance}
    </Typography>
  );
}

export default BalanceValue;